// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host .document-requests-container {
  height: 425px;
  overflow: auto;
  border-bottom: 1px solid #ddd;
}
:host .document-requests-container .message {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ddd;
  padding: 0.75rem 0;
  color: #4b5b70;
}
:host .document-requests-container .message .message-detail span {
  margin-right: 1.5rem;
  font-size: 12px;
}
:host .document-requests-container .message:last-child {
  border-bottom: 0;
}
:host .cursor-pointer {
  cursor: pointer;
}
:host .badge {
  width: 15px;
  height: 15px;
}
:host .unit-detail cs-icon {
  width: 13px;
  height: 13px;
}
:host .msg {
  font-size: 11px;
  margin-left: 0;
  color: #808080;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
